import { isSupabaseConfigured, supabase } from "@/lib/supabase";

export interface Category {
  id: string;
  name: string;
  created_at: string;
}

export async function getCategories(): Promise<Category[]> {
  if (!isSupabaseConfigured || !supabase) return [];
  const { data, error } = await supabase
    .from("categories")
    .select("*")
    .order("name");
  if (error) throw error;
  return (data as Category[]) || [];
}

export async function createCategory(name: string): Promise<Category> {
  if (!isSupabaseConfigured || !supabase) throw new Error("Supabase no configurado");
  const { data, error } = await supabase
    .from("categories")
    .insert({ name: name.trim() })
    .select()
    .single();
  if (error) throw error;
  return data as Category;
}

export async function deleteCategory(id: string): Promise<void> {
  if (!isSupabaseConfigured || !supabase) return;
  const { error } = await supabase.from("categories").delete().eq("id", id);
  if (error) throw error;
}

export async function getContentCategoryIds(contentItemId: string): Promise<string[]> {
  if (!isSupabaseConfigured || !supabase) return [];
  const { data, error } = await supabase
    .from("content_categories")
    .select("category_id")
    .eq("content_item_id", contentItemId);
  if (error) throw error;
  return (data || []).map((r) => r.category_id);
}

export async function saveContentCategories(contentItemId: string, categoryIds: string[]): Promise<void> {
  if (!isSupabaseConfigured || !supabase) return;
  // Delete existing
  const { error: deleteError } = await supabase
    .from("content_categories")
    .delete()
    .eq("content_item_id", contentItemId);
  if (deleteError) throw deleteError;
  // Insert new
  if (categoryIds.length > 0) {
    const rows = categoryIds.map((cid) => ({ content_item_id: contentItemId, category_id: cid }));
    const { error: insertError } = await supabase.from("content_categories").insert(rows);
    if (insertError) throw insertError;
  }
}
